/* src/app/modules/search/components/doc-view/components/doc-loader/doc-loader.component.scss */
.loader {
  position: relative;
  animation: envFloating 1s ease-in infinite alternate;
}
@keyframes envFloating {
  0% {
    transform: translate(-0.125rem, -0.3125rem);
  }
  100% {
    transform: translate(0, 0.3125rem);
  }
}
.dots-container {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.dots-container .dot {
  height: 0.25rem;
  width: 0.25rem;
  margin-right: 0.625rem;
  border-radius: 10px;
  background-color: var(--primary-400);
  animation: pulse 1.5s infinite ease-in-out;
}
.dots-container .dot:last-child {
  margin-right: 0;
}
.dots-container .dot:nth-child(1) {
  animation-delay: -0.3s;
}
.dots-container .dot:nth-child(2) {
  animation-delay: -0.1s;
}
.dots-container .dot:nth-child(3) {
  animation-delay: 0.1s;
}
@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: var(--primary-800);
    box-shadow: 0 0 0 0 rgba(178, 252, 247, 0.7);
  }
  50% {
    transform: scale(1.2);
    background-color: var(--primary-700);
    box-shadow: 0 0 0 10px rgba(178, 252, 247, 0);
  }
  100% {
    transform: scale(0.8);
    background-color: var(--primary-600);
    box-shadow: 0 0 0 0 rgba(178, 252, 252, 0.7);
  }
}
/*# sourceMappingURL=doc-loader.component.css.map */
